import { getAportes, postCalcularFondo } from "../../services/calculators";

import Modal from "../common/Modal";
import React from "react";
import { convertToMoney } from "../../utils/number";
import { useAPIs } from "../../apis/APIsConfig";
import { useState } from "react";
import { CalcularFondoModel } from "../../models/calcularfondos";
import { maxNumber } from "../../services/utils";

export function Pension({ ...props }) {
  useAPIs();

  const [isOpen, setIsOpen] = useState(false);

  function calculate() {
    let model = new CalcularFondoModel();
    model.edadActual = +props.formState.data.Edad;
    model.edadRetiro = +props.formState.data.EdadRetiro;
    model.salarioActual = +props.formState.data.Salario;
    model.montoCCI = +props.formState.data.MontoCCI;
    model.aporteExtraodinario = +props.formState.data.AporteExtra;
    model.sexo = props.formState.data.Genero;
    model.aporteVoluntario = +props.formState.data.AporteVoluntario;

    postCalcularFondo(model).then((calcRes) => {
      if (calcRes && calcRes.data) {
        const finalData = calcRes.data.value;

        getAportes(0).then((resAportes) => {
          finalData.push({
            id: 1000,
            valor: resAportes.data.value.salarioMaximo,
          });
          finalData.push({
            id: 1001,
            valor: resAportes.data.value.pensionMinimaRegimen,
          });

          props.setData(finalData);
        });
      }
    });
  }

  function disableButton() {
    return !(
      props.formState.data.Salario &&
      props.formState.data.Salario > 0 &&
      props.formState.data.Edad &&
      props.formState.data.Edad > 15 &&
      props.formState.data.EdadRetiro &&
      +props.formState.data.EdadRetiro >= +props.formState.data.Edad &&
      props.formState.data.Genero
    );
  }

  function getObject(id: number) {
    return props.data.find((o) => o.id === id) || {};
  }

  return (
    <div className="w-full pt-14">
      <div className="grid grid-cols-1 xlg:grid-cols-2 gap-10 xlg:gap-8 xxl:gap-20">
        <form
          className="block"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <p className="text-body-1 text-neutral-black font-body font-normal mb-2">
            Género
          </p>
          <div className="grid grid-cols-2 gap-x-4 gap-y-8">
            <label className="checkbox">
              <input
                type="radio"
                name="gender"
                value="M"
                checked={props.formState.data.Genero === "M"}
                onChange={props.changeHandler("Genero")}
              />
              <p>Masculino</p>
            </label>
            <label className="checkbox">
              <input
                type="radio"
                name="gender"
                value="F"
                checked={props.formState.data.Genero === "F"}
                onChange={props.changeHandler("Genero")}
              />
              <p>Femenino</p>
            </label>
            <div className="form-group">
              <label>Edad Actual</label>
              <input
                type="number"
                className="form-control age large"
                placeholder="Años"
                value={props.formState.data.Edad}
                onChange={props.changeHandler("Edad")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(3)}
              />
            </div>
            <div className="form-group">
              <label>Edad de Retiro</label>
              <input
                type="number"
                className="form-control age large"
                placeholder="Años"
                value={props.formState.data.EdadRetiro}
                onChange={props.changeHandler("EdadRetiro")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(3)}
              />
            </div>
            <div className="form-group col-span-2">
              <label>Monto Acumulado CCI al último corte</label>
              <input
                type="number"
                className="form-control large"
                placeholder="RD$ 0.00"
                value={props.formState.data.MontoCCI}
                onChange={props.changeHandler("MontoCCI")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(10)}
              />
            </div>
            <div className="form-group col-span-2">
              <label>Salario</label>
              <input
                type="number"
                className="form-control large"
                placeholder="RD$ 0.00"
                value={props.formState.data.Salario}
                onChange={props.changeHandler("Salario")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(9)}
              />
            </div>
            <div className="form-group col-span-2">
              <label>Aporte Voluntario Ordinario (%)</label>
              <input
                type="number"
                className="form-control large"
                placeholder="% 0.00"
                value={props.formState.data.AporteVoluntario}
                onChange={props.changeHandler("AporteVoluntario")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(3)}
              />
            </div>
            <div className="form-group col-span-2">
              <label>Aportes Voluntarios Extraordinarios (RD$)</label>
              <input
                type="number"
                className="form-control large"
                placeholder="RD$ 0.00"
                value={props.formState.data.AporteExtra}
                onChange={props.changeHandler("AporteExtra")}
                pattern="[0-9]*"
                onKeyPress={maxNumber(9)}
              />
            </div>
            <button
              type="button"
              className="btn btn-primary btn-large col-span-2"
              onClick={calculate}
              disabled={disableButton()}
            >
              Calcular
            </button>
          </div>
        </form>
        {/*
         ************ RESULTADOS ***********
         */}
        {props.data.length > 0 && (
          <div className="block">
            <div className="block bg-neutral-white border border-gray-10 shadow-box px-6 pt-6 pb-10">
              <h4 className="text-gray-70 font-bold border-b border-gray-5 pb-6 mb-6">
                Resultados
              </h4>
              <div className="grid xlg:grid-cols-2 gap-6">
                <div className="block">
                  <h5 className="text-body-1 text-gray-70 font-body font-bold mb-4">
                    Proyección de tu Retiro
                  </h5>
                  <div className="block space-y-6">
                    <div className="info-card">
                      <p>{getObject(4).descripcion}</p>
                      <h5>RD$ {convertToMoney(getObject(4).valor)}</h5>
                    </div>
                    <div className="info-card">
                      <p>{getObject(1).descripcion}</p>
                      <h5>RD$ {convertToMoney(getObject(1).valor)}</h5>
                    </div>
                    <div className="info-card">
                      <p>{getObject(6).descripcion}</p>
                      <h5>{convertToMoney(getObject(6).valor)}</h5>
                    </div>
                    <div className="info-card">
                      <p>{getObject(3).descripcion}</p>
                      <h5>RD$ {convertToMoney(getObject(3).valor)}</h5>
                    </div>
                  </div>
                </div>
                <div className="block">
                  <h5 className="text-body-1 text-gray-70 font-body font-bold mb-4">
                    Proyección con Aportes{" "}
                  </h5>
                  <div className="block space-y-6">
                    <div className="info-card">
                      <p>{getObject(5).descripcion}</p>
                      <h5>RD$ {convertToMoney(getObject(5).valor)}</h5>
                    </div>
                    <div className="info-card">
                      <p>{getObject(2).descripcion}</p>
                      <h5>RD$ {convertToMoney(getObject(2).valor)}</h5>
                    </div>
                    <div className="info-card">
                      <p>{getObject(7).descripcion}</p>
                      <h5>{convertToMoney(getObject(7).valor)}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center pt-6 md:pt-10">
              <button
                className="btn btn-secondary btn-medium"
                onClick={() => setIsOpen(true)}
              >
                Ver Suposiciones de Resultados Estimados
              </button>
            </div>
          </div>
        )}
      </div>
      <Modal
        title="Suposiciones de Resultados Estimados"
        show={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="info-card">
          <p>La rentabilidad nominal anual es de:</p>
          <h5>12.35%</h5>
          <small>(Consistente con supuestos de inflación de largo plazo)</small>
        </div>
        <div className="info-card">
          <p>La rentabilidad real anual es de:</p>
          <h5>5.00%</h5>
          <small>
            De acuerdo a la resolución 334-12 y circular 77-11 de la
            superintendencia de pensiones, que establece la metodología de
            cálculo para pensiones que se otorguen mediante retiro.
          </small>
        </div>
        <div className="info-card">
          <p>Aumento real del salario anual:</p>
          <h5>1.00%</h5>
        </div>
        <div className="info-card">
          <p>Salario máximo cotizable: </p>
          <h5>RD$ {convertToMoney(getObject(1000).valor)}</h5>
          <small>Con efectividad al 01/04/2025</small>
        </div>
        <div className="info-card">
          <p>
            De acuerdo al art.57 de la Ley 87-01 que define el límite mínimo y
            máximo del salario cotizable
          </p>
        </div>
        <div className="info-card">
          <p>
            Según lo establecido en la resolución 01/2025,{" "}
            <b>
              la pensión mínima del régimen contributivo es de RD${" "}
              {convertToMoney(getObject(1001).valor)}
            </b>{" "}
            (a partir del 01/04/2025)
          </p>
        </div>
        <div className="info-card">
          <p>
            El afiliado trabajará, desde la edad actual hasta el momento de
            retiro, sin interrupciones
          </p>
        </div>
        <div className="info-card">
          <p>
            <b>Fuente: </b>Superintendencia de Pensiones (SIPEN)
          </p>
        </div>
      </Modal>
    </div>
  );
}
